/* global attachEvent */
// *******************************************************************************
// 1.0 - Mobile menu toggle
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.mobile-hamburger');

  if (hamburger.classList.contains('is-open')) {
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
  } else {
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
  }
});

// *******************************************************************************
// 2.0 - Add class to body after some scroll
// *******************************************************************************
window.onscroll = function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;

  if (topOffert > 200) {
    document.body.classList.add('is-scrolled');
  } else {
    document.body.classList.remove('is-scrolled');
  }
};
